import React from 'react';
import { Grid } from '@material-ui/core';
import { CashFlow } from '../../modules';
import { PaddedContainer } from '../../ui-kit';

const CashFlowView = () => (
    <PaddedContainer padding={4}>
        <Grid item xs={12}>
            <CashFlow />
        </Grid>
    </PaddedContainer>
);

export default CashFlowView;
